export const getFirmStatus = (environments = []) => {
	const {eitje, active, demo, expired, inactive} = getEnvironmentStatuses(environments)

	if (eitje.length > 0) return 'eitje'
	if (active.length > 0) return 'active'
	if (demo.length > 0) return 'demo'
	if (expired.length > 0) return 'expired'
	if (inactive.length > 0) return 'inactive'
	return 'unattached'
}

export const getEnvironmentStatuses = (environments = []) => {
	const active = environments.filter(env => env.status === 'active')
	const inactive = environments.filter(env => env.status === 'inactive')
	const eitje = environments.filter(env => env.status === 'eitje')
	const demo = environments.filter(env => env.status === 'demo')
	const expired = environments.filter(env => env.status === 'expired')

	return {
		active,
		inactive,
		eitje,
		demo,
		expired,
	}
}
